var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.layout
    ? _c("w-select", {
        attrs: {
          fancy: _vm.fancy,
          items: _vm.items,
          label: _vm.label,
          value: _vm.value,
          disabled: _vm.disabled,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }